import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { machineryService } from '../../../services/machineryService';
import Toast from '../../../components/Common/Toast';

const CreateKilometer = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });
  const [formData, setFormData] = useState({
    vehicle_id: '',
    reading_date: new Date().toISOString().split('T')[0],
    kilometers: '',
    previous_kilometers: '',
    driver: '',
    notes: ''
  });

  useEffect(() => {
    loadVehicles();
  }, []);

  const loadVehicles = async () => {
    try {
      const response = await machineryService.getVehicles();
      if (response.success) setVehicles(response.data);
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al cargar vehículos', type: 'error' });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.vehicle_id) {
      setToast({ isOpen: true, message: 'Debe seleccionar un vehículo', type: 'error' });
      return;
    }
    setLoading(true);
    try {
      const vehicle = vehicles.find(v => v.id === parseInt(formData.vehicle_id));
      const data = {
        vehicle_id: parseInt(formData.vehicle_id),
        vehicle_code: vehicle?.code || '',
        vehicle_name: vehicle?.name || '',
        reading_date: formData.reading_date,
        kilometers: parseInt(formData.kilometers) || 0,
        previous_kilometers: parseInt(formData.previous_kilometers) || 0,
        kilometers_difference: (parseInt(formData.kilometers) || 0) - (parseInt(formData.previous_kilometers) || 0),
        driver: formData.driver,
        notes: formData.notes
      };
      const response = await machineryService.createKilometer(data);
      if (response.success) {
        setToast({ isOpen: true, message: 'Registro de kilómetros creado exitosamente', type: 'success' });
        setTimeout(() => navigate('/machinery/kilometers'), 1500);
      } else {
        setToast({ isOpen: true, message: response.message || 'Error al crear', type: 'error' });
      }
    } catch (error) {
      setToast({ isOpen: true, message: 'Error al crear el registro', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">
      <div className="max-w-2xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nuevo Registro de Kilómetros</h1>
          <p className="text-gray-600 mt-1">Registre el kilometraje de un vehículo</p>
        </div>
        <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="space-y-6">
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Vehículo *</label>
              <select name="vehicle_id" value={formData.vehicle_id} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
                <option value="">Seleccione un vehículo</option>
                {vehicles.map(v => <option key={v.id} value={v.id}>{v.code} - {v.name} ({v.license_plate})</option>)}
              </select>
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Fecha de Lectura *</label>
              <input type="date" name="reading_date" value={formData.reading_date} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Kilómetros Anteriores</label>
              <input type="number" name="previous_kilometers" value={formData.previous_kilometers} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Kilómetros Actuales *</label>
              <input type="number" name="kilometers" value={formData.kilometers} onChange={handleChange} required className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Conductor</label>
              <input type="text" name="driver" value={formData.driver} onChange={handleChange} className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
            <div><label className="block text-sm font-medium text-gray-700 mb-2">Notas</label>
              <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
            </div>
          </div>
          <div className="mt-6 flex gap-4">
            <button type="submit" disabled={loading} className="px-6 py-2.5 bg-teal-600 hover:bg-teal-700 disabled:bg-gray-400 text-white rounded-lg font-medium transition-colors">
              {loading ? 'Guardando...' : 'Guardar'}
            </button>
            <button type="button" onClick={() => navigate('/machinery/kilometers')} className="px-6 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-lg font-medium transition-colors">
              Cancelar
            </button>
          </div>
        </form>
      </div>
      <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
    </div>
  );
};

export default CreateKilometer;
